import { useMutation } from '@tanstack/react-query';
import { GET, GET_EXAMPLE_TEMPLATE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { downloadBlobFile } from '../../../utils/blob';

export const useDownloadTemplate = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_EXAMPLE_TEMPLATE(), undefined, { responseType: 'blob' });

      downloadBlobFile(response, 'example_template.xlsx');

      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ดาวน์โหลดเทมเพลตสำเร็จ' });
    },
  });
  return { mutate, loading: isPending };
};
